export function addOneDayOnDate(date: Date, numberOfDay: number): Date {
  const nouvelleDate = new Date(date);

  // Ajouter un jour à la date
  nouvelleDate.setDate(nouvelleDate.getDate() + numberOfDay);

  return nouvelleDate;
}
